import { render, staticRenderFns } from "./OptionAnalyticsTab.vue?vue&type=template&id=b3d9d9cc"
import script from "./OptionAnalyticsTab.vue?vue&type=script&lang=ts"
export * from "./OptionAnalyticsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports